import React from 'react';
import { Link } from 'react-router-dom';
import './ResourceTest.css';
import Button from '../../App/Common/Button/Button';

const ResourseTestEnding = ({ data }) => {
  const hours = Math.floor(data.time_spent / 3600);
  const minutes = Math.floor((data.time_spent % 360000) / 60);
  const seconds = Math.floor((data.time_spent % 60) / 1);

  // console.log(data);

  return (
    <div className='resourseTest__container'>
      <div className='resourseTest__table'>
        <div className='resourseTest__field'>
          Тест:
          <div className='resourseTest__data'>{data.title}</div>
        </div>
        <div className='resourseTest__field'>
          Количество попыток:
          <div className='resourseTest__data'>
            {data.attempts_number > 0
              ? data.attempts_used + '/' + data.attempts_number
              : 'Не ограничено'}
          </div>
        </div>
        <div className='resourseTest__field'>
          Затрачено времени:
          <div className='resourseTest__data'>{`${hours
            .toString()
            .padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds
            .toString()
            .padStart(2, '0')}`}</div>
        </div>
        <div className='resourseTest__field'>
          Количество вопросов:
          <div className='resourseTest__data'>{data.num_of_questions}</div>
        </div>
        <div className='resourseTest__field'>
          Выполнено верно:
          <div className='resourseTest__data'>{`${
            data.user_result ? data.user_result : 0
          }%`}</div>
        </div>
      </div>
      <div className='resourseTest__buttons'>
        <Link to={!data.hide_result ? `/test/${data.id}/result` : ''}>
          {' '}
          <Button
            disabled={
              data.hide_result 
            }
            buttonText={'Посмотреть результаты'}
            color={'#7A5AF8'}
            type={'filled'}
          />
        </Link>
        <Link
          to={
            (data.attempts_number &&
              data.attempts_used === data.attempts_number) || (data.user_result == null && data.attempts_used !== null)
              ? null
              : `/test/${data.id}`
          }
        >
          {' '}
          <Button
            disabled={(data.attempts_number!==0) &&
              ((data.attempts_number &&
                data.attempts_used === data.attempts_number)) || (data.user_result == null && data.attempts_used !== null)
            }
            buttonText={`Пройти еще раз (${data.attempts_used}/${
              data.attempts_number ? data.attempts_number : '∞'
            })`}
            color={'#22C532'}
            type={'filled'}
          />
        </Link>
      </div>
    </div>
  );
};
export default ResourseTestEnding;
